/* eslint-disable no-redeclare */
import React from 'react';
import NavRouter from '../NavRouter';
import './AdminTab.scss';

interface AdminTab{
  tabs: any;
}
const AdminTab = ({ tabs }:AdminTab) => (
  <div>
    <NavRouter data={tabs} tabStyle="admin-details-merchant-tab" />
  </div>
);

export default AdminTab;
